import { useEffect } from 'react'

import { ROUTES } from '@/constants'
import { useRouter } from '@/i18n-routing'

// Routes where popstate is forward navigation — should not trigger the redirect.
// endsWith handles locale-prefixed URLs (e.g. /de/checkout).
const PURCHASE_FUNNEL_ROUTES = [
	ROUTES.pricing,
	ROUTES.plans,
	ROUTES.checkout.index,
	ROUTES.checkout.plans,
	ROUTES.checkout.upgrade,
]

const isForwardToPurchaseFunnel = (pathname: string) =>
	PURCHASE_FUNNEL_ROUTES.some(
		(route) => pathname === route || pathname.endsWith(route),
	)

export const useRedirectOnBackNavigation = (redirectUrl: string | null) => {
	const router = useRouter()

	useEffect(() => {
		if (!redirectUrl) return

		const onPopState = () => {
			if (isForwardToPurchaseFunnel(window.location.pathname)) return
			router.replace(redirectUrl)
		}

		window.addEventListener('popstate', onPopState)

		return () => {
			setTimeout(() => window.removeEventListener('popstate', onPopState), 0)
		}
	}, [redirectUrl, router])
}
